export const searchItems = (query: string, item: any): boolean => {
  const lowerQuery = query.toLowerCase();

  // Check if the item name matches the query
  const nameMatch = item.title.toLowerCase().includes(lowerQuery);

  // Check if any detail value matches the query
  const detailMatch = item.subTab.some((detail: any) =>
    detail.subTabLabel.toLowerCase().includes(lowerQuery)
  );

  return nameMatch || detailMatch;
};
